import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import adminApi from '../../lib/adminApi';
import { toast } from 'sonner';
import { GestorePageHeader } from '../../components/gestore/GestorePageHeader';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Save } from 'lucide-react';

const ROLES = ['admin', 'manager', 'cashier', 'waiter'];

export default function GestoreSections() {
  const { t } = useTranslation();
  const [sections, setSections] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = async () => { const { data } = await adminApi.get('/admin/sections'); setSections(data.sections); };
  useEffect(() => { load(); }, []);

  const toggleEnabled = (key) => setSections((s) => s.map((x) => x.key === key ? { ...x, enabled: !x.enabled } : x));
  const toggleRole = (key, role) => setSections((s) => s.map((x) => {
    if (x.key !== key) return x;
    const roles = x.roles.includes(role) ? x.roles.filter((r) => r !== role) : [...x.roles, role];
    return { ...x, roles };
  }));

  const save = async () => {
    setSaving(true);
    try { await adminApi.put('/admin/sections', { sections }); toast.success(t('gestore.sUpdated')); }
    catch (e) { toast.error(t('gestore.sError')); } finally { setSaving(false); }
  };

  return (
    <div className="px-4 md:px-6 lg:px-8 py-4 md:py-6 max-w-4xl">
      <GestorePageHeader title={t('gestore.sTitle')} subtitle={t('gestore.sSubtitle')}>
        <Button onClick={save} disabled={saving} className="rounded-xl" data-testid="sections-save-button"><Save className="h-4 w-4 mr-2" /> {saving ? t('gestore.sSaving') : t('gestore.sSave')}</Button>
      </GestorePageHeader>
      <Card className="p-0 overflow-hidden">
        <div className="grid grid-cols-[1fr_auto] gap-0 divide-y divide-border">
          <div className="contents">
            <div className="px-5 py-3 bg-muted font-semibold text-sm">{t('gestore.sSection')}</div>
            <div className="px-5 py-3 bg-muted font-semibold text-sm text-right">{t('gestore.sActive')}</div>
          </div>
        </div>
        <div className="divide-y divide-border">
          {sections.map((s) => (
            <div key={s.key} className="px-5 py-4" data-testid={`section-row-${s.key}`}>
              <div className="flex items-center justify-between">
                <div className="font-medium">{t(`nav.${s.key}`, { defaultValue: s.label })}</div>
                <Switch checked={s.enabled} onCheckedChange={() => toggleEnabled(s.key)} data-testid={`section-toggle-${s.key}`} />
              </div>
              <div className="flex flex-wrap gap-2 mt-3">
                {ROLES.map((r) => {
                  const on = s.roles.includes(r);
                  return (
                    <button key={r} disabled={!s.enabled} onClick={() => toggleRole(s.key, r)}
                      className={`text-xs px-3 h-8 rounded-full border transition-colors disabled:opacity-40 ${on ? 'border-primary bg-primary/10 text-primary' : 'border-border text-muted-foreground hover:bg-muted'}`}>
                      {t(`roles.${r}`)}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </Card>
      <p className="text-xs text-muted-foreground mt-3">{t('gestore.sFooter')}</p>
    </div>
  );
}
